import { environment } from '../../environments/environment';

export const backendServiceUrl = environment.REST_ENDPOINT || 'http://localhost:3000';
export const crmServiceUrl = environment.CRM_SERVICE_URL;
export const locationServiceUrl = environment.LOCATION_SERVICE_URL;
export const dimAdminApiUrl =
    (environment as { DIM_ADMIN_API_URL?: string }).DIM_ADMIN_API_URL || 'http://localhost:3005';
export const pdObserverUrl = (environment as { PD_OBSERVER_URL?: string }).PD_OBSERVER_URL || 'http://localhost:3010';
